module.exports = __webpack_public_path__ + "static/media/fenix.f3c05c7b.jpg";